import { render, staticRenderFns, recyclableRender, components } from "./datePicker.vue?vue&type=template&id=f581ce56&scoped=true&"
var renderjs
import script from "./datePicker.vue?vue&type=script&lang=js&"
export * from "./datePicker.vue?vue&type=script&lang=js&"
import style0 from "./datePicker.vue?vue&type=style&index=0&id=f581ce56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f581ce56",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/common/datePicker.vue"
export default component.exports